import React, { useState, useEffect } from "react"
import { useSiteContext } from "../hooks/use-site-context"
import audioData from "../data/audioData.json"
import { MdPlayArrow, MdPause, MdVolumeOff, MdVolumeUp } from "react-icons/md"
import { FaStar } from "react-icons/fa"
import { IoStar } from "react-icons/io5"

const Subtitles = () => {
  const {
    currentStep,
    currentAudioStage,
    selectedSign,
    currentAudioTime,
    mainAudio,
    firstName,
    progressBarPercent,
  } = useSiteContext()

  const [finalCaption, setFinalCaption] = useState("")

  const [presentCaptions, setPresentCaptions] = useState(
    audioData.find(data => data.stage === currentAudioStage).captions
  )

  useEffect(() => {
    setPresentCaptions(
      audioData.find(data => data.stage === currentAudioStage).captions
    )
  }, [currentAudioStage])

  useEffect(() => {
    const currentCaption = presentCaptions.reduce((prev, curr) => {
      return curr.time <= currentAudioTime ? curr : prev
    }, null)

    // Combined replace function
    const parsedHTML = currentCaption?.text.replace(
      /(\[star sign\]|\[first letter\]|#([^#]+)#)/g,
      (match, placeholder, hashtag) => {
        if (placeholder === "[star sign]") {
          return selectedSign
        } else if (placeholder === "[first letter]") {
          // Get the first letter of the selected sign
          return (
            '<span class="text-brand-gold">' +
            firstName.charAt(0).toUpperCase() +
            "</span>"
          )
        } else if (hashtag) {
          // Handle hashtag replacement
          return '<span class="text-brand-gold">' + hashtag + "</span>"
        }
        return match // Return the original match if no replacement is needed
      }
    )

    if (currentAudioTime > 0) setFinalCaption(parsedHTML)
  }, [currentAudioTime])

  function scrollUp() {
    const isFirefox = navigator.userAgent.toLowerCase().includes("firefox")

    if (isFirefox) {
      // Custom smooth scroll for Firefox
      const smoothScrollToTop = () => {
        let currentScroll = window.scrollY
        if (currentScroll > 0) {
          window.scrollTo(0, currentScroll - currentScroll / 8) // Adjust easing factor if needed
          requestAnimationFrame(smoothScrollToTop)
        }
      }
      requestAnimationFrame(smoothScrollToTop)
    } else {
      // Native smooth scroll for Chrome, Safari, and others
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      })
    }
  }

  return (
    <>
      <div
        onClick={() => scrollUp()}
        className={`${
          currentStep === 2 && "fade-in-slow"
        } fixed z-50 bottom-2 left-1/2 -translate-x-1/2 px-3 w-full max-w-5xl`}
      >
        <div className="px-3 py-6 bg-black md:px-6 bg-opacity-80">
          <div
            className="text-xl text-center text-white md:text-2xl"
            dangerouslySetInnerHTML={{ __html: finalCaption }}
          ></div>
        </div>
        <div
          style={{ backgroundColor: "rgba(168, 24, 129, 0.5)" }}
          className="relative w-full h-4"
        >
          <div
            style={{ width: `${progressBarPercent}%` }}
            className={`h-4 bg-brand-darkPink`}
          ></div>

          <div className="absolute bottom-0 right-0 translate-x-1/2">
            <IoStar className="w-5 h-5 text-brand-gold star-pulse" />
          </div>
          <div className="absolute bottom-0 -translate-x-1/2 left-1/3">
            <IoStar className="w-3.5 h-3.5 text-brand-gold" />
          </div>
          <div className="absolute bottom-0 -translate-x-1/2 left-2/3">
            <IoStar className="w-4 h-4 text-brand-gold" />
          </div>
        </div>
      </div>
    </>
  )
}

export default Subtitles
